import { api } from "api";

export const getIntroVideos = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/document/get-introducing-videos")
      .then((res) => {
        dispatch({
          type: "GET_INTRO_VIDEOS_SUCCESS",
          payload: res.data.data.videos,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_INTRO_VIDEOS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
